module.exports = __webpack_public_path__ + "img/img-example.17fcc8d9.jpg";